import React, { useEffect, useState } from "react";
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, Stack, Tab, Tabs } from "@mui/material";
import TableComp from "src/components/shared/table/TableComp";
import { CHECK_ORDER_BULK_PREPARE, orderStatusFormatted, PREPARE_BULK_TAB } from "src/constant";
import usePrepareBulkBody from "../utils/prepare-bulk/usePrepareBulkBody";
import useAuthGlobal from "src/context/useAuthGlobal";
import useQueryParams from "src/hooks/useQueryParams";
import PrepareBulkPrint from "./PrepareBulkPrint";
import AdvanceFilter from "src/components/shared/AdvenceFilter";
import useAppGlobal from "src/context/useAppGlobal";
import OrderDetailDialog from "../all-order/OrderDetailDialog";
import PrepareBulkOrder from "./PrepareBulkOrder";
import DateRangePicker from "src/components/shared/DateRangePicker";

const childTabs = [
  { id: PREPARE_BULK_TAB.quickPrepare, name: "Soạn hàng hàng loạt" },
  { id: PREPARE_BULK_TAB.createSlip, name: "Tạo phiếu hàng loạt" },
];

const orderStatus = [
  { id: orderStatusFormatted.WaitToExport, name: "Chuẩn bị hàng" },
  { id: orderStatusFormatted.ReadyToPick, name: "Đã xuất hàng" },
];

const orderPrintedStatus = [
  { id: false, name: "Chưa in" },
  { id: true, name: "Đã in" },
];

export default function PrepareBulkPage({ mutate }) {
  const [option, setOption] = useQueryParams();
  const { userMe } = useAuthGlobal();
  const { handleOpenDialog } = useAppGlobal();
  const [total, setTotal] = useState([]);
  const [paramsQuery, setParamsQuery] = useState();
  const [orderState, setOrderState] = useState({ status: orderStatus[0].id, isPrint: orderPrintedStatus[0].id });
  const [date, setDate] = useState();

  const activeChild = option?.child ?? PREPARE_BULK_TAB.quickPrepare;

  const openPrintDialog = (order) => {
    handleOpenDialog({
      title: "In phiếu",
      content: (
        <OrderDetailDialog
          id={order?._id}
          whouseId={order?.warehouse}
        />
      ),
      size: "xl",
    });
  };

  const { header, bodyList, sortData } = usePrepareBulkBody({
    setTotal,
    total,
    userMeWHouse: userMe?.currentWarehouse?._id,
    paramsQuery,
    orderState,
    date,
    onPrintOrder: (order) => openPrintDialog(order),
  });

  useEffect(() => {
    if (!option?.tab || option.tab !== CHECK_ORDER_BULK_PREPARE.prepareBulk) return;
    if (!option?.child) {
      setOption({
        ...option,
        tab: CHECK_ORDER_BULK_PREPARE.prepareBulk,
        child: PREPARE_BULK_TAB.quickPrepare,
      });
    }
  }, [option?.tab, option?.child]);

  const handleChildTab = (_, value) => {
    setOption({
      ...option,
      tab: CHECK_ORDER_BULK_PREPARE.prepareBulk,
      child: value,
    });
  };

  const onChangeOrderState = (name, value) => {
    setOrderState((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <Stack
        gap={1.5}
        mb={1.5}
      >
        <Box
          display="flex"
          justifyContent="space-between"
        >
          <Box
            width="100%"
            display="flex"
            justifyContent="flex-start"
            gap={1.5}
          >
            <FormControl size="small">
              <InputLabel id="demo-simple-select-label">Trạng thái đơn hàng</InputLabel>
              <Select
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={orderState.status}
                label="Trạng thái đơn hàng"
                onChange={(e) => onChangeOrderState("status", e.target.value)}
              >
                {orderStatus.map((v) => {
                  return <MenuItem value={v.id}>{v.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <FormControl size="small">
              <InputLabel id="demo-simple-select-label">Trạng thái in</InputLabel>
              <Select
                size="small"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={orderState.isPrint}
                label="Trạng thái in"
                onChange={(e) => onChangeOrderState("isPrint", e.target.value)}
              >
                {orderPrintedStatus.map((v) => {
                  return <MenuItem value={v.id}>{v.name}</MenuItem>;
                })}
              </Select>
            </FormControl>
            <DateRangePicker
              value={date ?? { fromDate: null, toDate: null }}
              onApply={setDate}
              label={!!date ? "" : "Thời gian tạo phiếu"}
            />
          </Box>
          <AdvanceFilter
            setParamsQuery={setParamsQuery}
            paramsQuery={paramsQuery}
          />
        </Box>
        <Box sx={{ borderBottom: "1px solid var(--grey)", width: "100%" }}>
          <Tabs
            value={activeChild}
            onChange={handleChildTab}
            variant="scrollable"
            scrollButtons="auto"
            sx={{ minHeight: "36px !important" }}
          >
            {childTabs.map((v) => (
              <Tab
                key={v.id}
                value={v.id}
                label={v.name}
                sx={{
                  p: "4px 16px !important",
                  minHeight: "36px !important",
                  borderBottom: activeChild === v.id ? "2px solid var(--black) !important" : "",
                }}
              />
            ))}
          </Tabs>
        </Box>
      </Stack>

      {activeChild === PREPARE_BULK_TAB.quickPrepare && <PrepareBulkOrder warehouseId={userMe?.currentWarehouse?._id} mutate={mutate} />}

      {activeChild === PREPARE_BULK_TAB.createSlip && (
        <Grid
          container
          spacing={2}
        >
          <Grid
            item
            xs={9}
          >
            <TableComp
              headers={header}
              bodyList={bodyList}
              sortData={sortData}
            />
          </Grid>
          <Grid
            item
            xs={3}
          >
            <PrepareBulkPrint
              orderState={orderState}
              total={total}
              warehouseId={userMe?.currentWarehouse?._id}
              setTotal={setTotal}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
